import React from "react";
import { formatIdDateTime } from "@/lib/format";
import { reasonLabel } from "@/hooks/useFraudSummary";

/** Single fraud-attempt row (used inside FraudAttemptsWidget list). */
export default function FraudRow({ item }) {
  return (
    <li
      className="p-2 hover:bg-secondary/30"
      data-testid={`fraud-attempt-row-${item.id}`}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <div className="text-sm font-bold text-red-700">
            {reasonLabel(item.meta)}
          </div>
          <div className="text-xs text-muted-foreground font-mono truncate">
            {item.meta?.no_spb || item.meta?.qr || "(no data)"}
          </div>
          <div className="text-[10px] font-mono text-muted-foreground mt-1">
            {item.user_email} · {formatIdDateTime(item.created_at)}
          </div>
        </div>
      </div>
    </li>
  );
}
